module.exports = __webpack_public_path__ + "static/assets/5bfdc9124d1f4f7aa82c981000b22d8b.png";